import { withInstall } from '@lit-element/utils'
import Mention from './src/mention.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtMention: SFCWithInstall<typeof Mention> = withInstall(Mention)
export default LtMention

export * from './src/mention'
